function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "8",
  height: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.518 3.602L1.445.07a.418.418 0 00-.463 0A.483.483 0 00.75.468v7.064c0 .164.093.328.232.398.07.047.162.07.232.07s.162-.023.231-.07l6.073-3.532A.483.483 0 007.75 4a.453.453 0 00-.232-.398z",
  fill: "currentColor"
})));